import { useContext } from 'react';
import { ModalWrapperContext } from '../providers/modal-wrapper-provider';
export default function useModal() {
  return useContext(ModalWrapperContext);
}